import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthStore } from '../store/auth.store';
import { ToastService } from '../services/toast.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  private authStore = inject(AuthStore);
  private router = inject(Router);
  private toastService = inject(ToastService);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    
    const isAuthInitialized = this.authStore.isAuthInitialized();
    const isAuthenticated = this.authStore.isAuthenticated();
    const isAdmin = this.authStore.isAdmin();
    
    // If auth is not initialized yet, allow access (will be handled by auth state change)
    if (!isAuthInitialized) {
      return true;
    }
    
    if (!isAuthenticated) {
      // Not authenticated, redirect to login
      const returnUrl = state.url;
      this.toastService.warning('Please log in to access this page.');
      return this.router.createUrlTree(['/login'], { 
        queryParams: { returnUrl } 
      });
    }
    
    if (!isAdmin) {
      // Authenticated but not admin
      this.toastService.error('You do not have permission to access this page.');
      return this.router.createUrlTree(['/']);
    }
    
    // User is authenticated and is admin
    return true;
  }
}